module.exports = __webpack_public_path__ + "static/media/womenphysique.4ed6c46d.jpg";